<script setup lang="ts">

import { faFilterCircleXmark } from '@fortawesome/pro-regular-svg-icons'

import { FilterDateRange } from '@shared/ui/filters'
import { BtnIcon, BtnPrimary } from '@shared/ui/buttons'
import { InputPrimary } from '@shared/ui/fields'

import { useFiltersEntityChangelog } from '../model/filters-entity-changelog.hook'

defineOptions({
  name: 'FiltersEntityChangelog',
})

const {
  refSearch,
  refDateRange,
  isLoading,
  setSearch,
  handleSearch,
  handleClear,
} = useFiltersEntityChangelog()
</script>

<template>
  <div class="filters-entity-changelog">
    <div class="filters-entity-changelog__fields">
      <InputPrimary
        id="entity-changelog-search"
        class="filters-entity-changelog__search"
        label="Search"
        type="text"
        placeholder="Search"
        :value="refSearch"
        :disabled="isLoading"
        @update:value="setSearch"
        @keyup:enter="handleSearch"
      />

      <FilterDateRange
        v-model="refDateRange"
        presets
        class="filters-entity-changelog__date"
        label="Date"
        placeholder="Search"
        :disabled="isLoading"
      />
    </div>

    <div class="filters-entity-changelog__controls">
      <BtnIcon
        :icon="faFilterCircleXmark"
        color="red"
        tooltip-text="Clear filters"
        :disabled="isLoading"
        @click="handleClear"
      />
      <BtnPrimary
        text="Search"
        :disabled="isLoading"
        @click="handleSearch"
      />
    </div>
  </div>
</template>

<style scoped lang="scss" src="./FiltersEntityChangelog.scss" />
